/**
 * The root route's auth gate statuses (routes/__root.tsx beforeLoad), and which of them open the app shell.
 * - authenticated: the Desk's own server signed this window in.
 * - hosted-static: the hosted pairing page (hostedPairing.ts), no server of its own.
 * - web-host: cleo-web, the browser host on the World backend (webHost.ts), no server of its own.
 * The others (hosted-pairing, requires-auth) show the pairing surface instead.
 */
export type ShellAuthGateStatus = "authenticated" | "hosted-static" | "web-host";

const OPEN: ReadonlySet<string> = new Set<ShellAuthGateStatus>([
  "authenticated",
  "hosted-static",
  "web-host",
]);

/** Pure: whether the app shell opens for this gate status (else the route sends the person to /pair). */
export function shellOpensFor(status: string): boolean {
  return OPEN.has(status);
}
